export default __webpack_public_path__ + "static/media/ic_order_noti.a78158cc.svg";